var _defs, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 190.70644 81.362694",
    id: "svg6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m 117.821,568.067 h 308.58 v 150.082 h -308.58 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "m 117.821,568.067 h 308.58 v 150.082 h -308.58 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m 117.821,568.067 h 308.58 v 150.082 h -308.58 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "m 117.821,568.067 h 308.58 v 150.082 h -308.58 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "m 117.821,568.067 h 308.58 v 150.082 h -308.58 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m 117.821,568.067 h 308.58 v 150.082 h -308.58 z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2b0d02",
      strokeWidth: 4.56005,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 2.280025,2.280025 H 188.42641 V 79.08267 H 2.280025 Z",
    id: "path1"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(2.5005614,0,0,0.91231814,-272.0041,-512.78957)",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "Teko",
      InkscapeFontSpecification: "'Teko, @wght=700'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fontVariationSettings: "'wght' 700",
      whiteSpace: "pre",
      shapeInside: "url(#a)",
      display: "inline"
    },
    id: "text1",
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 117.82031,
    y: 599.80751,
    id: "tspan7"
  }, "T"))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(2.5005614,0,0,0.91231814,-163.69075,-476.85172)",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "Teko",
      InkscapeFontSpecification: "'Teko, @wght=700'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fontVariationSettings: "'wght' 700",
      whiteSpace: "pre",
      shapeInside: "url(#b)",
      display: "inline"
    },
    id: "text2",
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 117.82031,
    y: 599.80751,
    id: "tspan8"
  }, "T"))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(2.5005614,0,0,0.91231814,-222.19873,-512.78957)",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "Teko",
      InkscapeFontSpecification: "'Teko, @wght=700'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fontVariationSettings: "'wght' 700",
      whiteSpace: "pre",
      shapeInside: "url(#c)",
      display: "inline"
    },
    id: "text3",
    xmlSpace: "preserve"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 117.82031,
    y: 599.80751,
    id: "tspan9"
  }, "A"))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(2.5005614,0,0,0.91231814,-164.79185,-512.78957)",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "Teko",
      InkscapeFontSpecification: "'Teko, @wght=700'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fontVariationSettings: "'wght' 700",
      whiteSpace: "pre",
      shapeInside: "url(#d)",
      display: "inline"
    },
    id: "text4",
    xmlSpace: "preserve"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 117.82031,
    y: 599.80751,
    id: "tspan10"
  }, "L"))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(2.5005614,0,0,0.91231814,-277.55557,-476.85172)",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "Teko",
      InkscapeFontSpecification: "'Teko, @wght=700'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fontVariationSettings: "'wght' 700",
      whiteSpace: "pre",
      shapeInside: "url(#e)",
      display: "inline"
    },
    id: "text5",
    xmlSpace: "preserve"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 117.82031,
    y: 599.80751,
    id: "tspan11"
  }, "A"))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(2.5005614,0,0,0.91231814,-221.02298,-476.85172)",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "Teko",
      InkscapeFontSpecification: "'Teko, @wght=700'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fontVariationSettings: "'wght' 700",
      whiteSpace: "pre",
      shapeInside: "url(#f)",
      display: "inline"
    },
    id: "text6",
    xmlSpace: "preserve"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 117.82031,
    y: 599.80751,
    id: "tspan12"
  }, "R"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/logo_3.fda5a311a76e79ac5d7dc9e1f7290f90.svg";
export { ForwardRef as ReactComponent };